import PageLayer from "@/Layouts/views/PageLayer";
import MyWashoutLayer from "../Layers/MyWashouts/MyWashoutLayer";
// Images
import Icon from "@/Washouts/assets/icons/my-washouts-icon-page.svg";

export default function MyWashouts() {
	return (
		<PageLayer title="My Washouts" icon={Icon}>
			<MyWashoutLayer />
		</PageLayer>
	);
}
